module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/HtIsam/tc-custom/9781611521153.jpg?1718106103455",
      "alt": "This image is the cover for the book Horsing Around"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Horsing Around\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("David Livingston has fallen -- and fallen hard -- for Marcus. With some confusion and a lot of nerves, he's taking Marcus home to the family for Christmas. With a high school sweetheart in the picture, lots of family around, and lots to do, there's not much time for privacy."), _c('br'), _c('br'), _vm._v("Too many pulls on his time and too many emotions swirl away in David's heart. Is he gay? Is this just a one-shot deal with Marcus, just a way to explore a mere curiosity? Or is it something deeper, something that will change his entire life?"), _c('br'), _c('br'), _vm._v("David and Marcus have to make some tough choices all in the middle of"), _c('em', [_vm._v("Horsing Around.")])]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Vincent Diamond\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0